import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import useAuthSession from './hooks/useAuthSession.js'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import PublicRoute from './components/PublicRoute.jsx'
import GlobalLoader from './components/GlobalLoader.jsx'
import LoginPage from './components/LoginPage.jsx'
import AppPage from './components/AppPage.jsx'
import HelloWorld from './components/HelloWorld.jsx'

/**
 * App component is the root of the application.
 * Manages routing between login and protected app views.
 *
 * @returns {React.ReactElement} App root
 */
function App() {
  const { session, isLoading } = useAuthSession()

  return (
    <BrowserRouter>
      {/* Show global loader during initial session check */}
      <GlobalLoader active={isLoading} />

      <Routes>
        {/* Public route - Login */}
        <Route
          path="/login"
          element={
            <PublicRoute session={session} isLoading={isLoading}>
              <LoginPage />
            </PublicRoute>
          }
        />

        {/* Public route - Hello World */}
        <Route path="/helloWord" element={<HelloWorld />} />

        {/* Protected route - Main app */}
        <Route
          path="/app"
          element={
            <ProtectedRoute session={session} isLoading={isLoading}>
              <AppPage />
            </ProtectedRoute>
          }
        />

        {/* Default redirect to /app (will be handled by ProtectedRoute) */}
        <Route path="/" element={<Navigate to="/app" replace />} />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
